import { queryOptions, skipToken, useQuery } from '@tanstack/react-query'
import { useAuth } from './useAuth'

type AuthFetch = ReturnType<typeof useAuth>['authFetch']

const getLegalEntitiesBySiteNrOptions = (
  authFetch: AuthFetch,
  siteNr?: number
) => {
  const hasSiteNr = siteNr !== undefined

  return queryOptions({
    queryKey: ['legal-entities', siteNr],
    queryFn: hasSiteNr
      ? async () => {
          const { data, error } = await authFetch().GET(
            '/fiskeridir/site/{site-nr}/license-connections',
            {
              params: {
                path: {
                  'site-nr': siteNr
                }
              }
            }
          )

          if (error) {
            throw new Error('Could not fetch legal entities for site')
          }

          return data ?? []
        }
      : skipToken
  })
}

export const useGetLegalEntitiesBySiteNrQuery = (siteNr?: number) => {
  const { authFetch } = useAuth()
  return useQuery(getLegalEntitiesBySiteNrOptions(authFetch, siteNr))
}
